import {
  AITranslationGlossaryEntryRequestDto,
  AITranslationGlossaryEntryResponseDto,
  ApiForAiSettingsService,
} from '@api'
import { attach, createEffect, createStore, sample } from 'effector'

import { $creatorId } from '@/models/creators.ts'
import { toast } from '@/models/toasts'
import { handleError } from '@/utils/error'

export const getGlossaryEntriesFx = attach({
  name: 'get Ai Settings',
  source: {
    creatorId: $creatorId,
  },
  mapParams: (_: void, { creatorId }) => ({
    creatorId: creatorId!,
  }),
  effect: createEffect(ApiForAiSettingsService.getGlossaryEntries),
})

export const addGlossaryEntryFx = attach({
  name: 'add glossary entry',
  source: {
    creatorId: $creatorId,
  },
  mapParams: (
    { original, translation }: AITranslationGlossaryEntryRequestDto,
    { creatorId },
  ) => ({
    creatorId: creatorId!,
    requestBody: { original, translation },
  }),
  effect: createEffect(ApiForAiSettingsService.addGlossaryEntry),
})

export const removeGlossaryEntryFx = attach({
  name: 'remove glossary entry',
  source: {
    creatorId: $creatorId,
  },
  mapParams: (glossaryId: number, { creatorId }) => ({
    creatorId: creatorId!,
    glossaryId: glossaryId,
  }),
  effect: createEffect(ApiForAiSettingsService.removeGlossaryEntry),
})

addGlossaryEntryFx.doneData.watch(() => {
  toast.success('Word added successfully')
})

addGlossaryEntryFx.failData.watch((error) =>
  handleError(error, 'Failed to add glossary entry'),
)

removeGlossaryEntryFx.doneData.watch(() => {
  toast.success('Word removed successfully')
})

removeGlossaryEntryFx.failData.watch((error) =>
  handleError(error, 'Failed to remove glossary entry'),
)

getGlossaryEntriesFx.failData.watch((error) => {
  handleError(error, 'Failed to load glossary entries', getGlossaryEntriesFx)
})

export const $glossaryEntries = createStore<
  AITranslationGlossaryEntryResponseDto[]
>([])
  .on(getGlossaryEntriesFx.doneData, (_, state) => state)
  .on(addGlossaryEntryFx.doneData, (state, payload) => [...state, payload])

sample({
  clock: [removeGlossaryEntryFx.doneData],
  target: getGlossaryEntriesFx,
})
